import React from 'react';
import type { IErrorConectDispatchVehicle } from '~/features/Device/TabListDevice/interfaces/IListDevicesprops';
import { useLang } from '~/hooks/useLang';

interface ShowPositionCrewProps {
  readonly typePosition: 'commander' | 'driver' | 'patrolman';
  readonly labelCommander?: string | null;
  readonly labelDriver?: string | null;
  readonly labelPatrolmans?: string | null;
  readonly error: IErrorConectDispatchVehicle;
}

export default function ShowPositionCrew({ typePosition, labelCommander, labelDriver, labelPatrolmans, error }: ShowPositionCrewProps) {
  const { translate } = useLang();

  const positionConfig = {
    commander: {
      label: labelCommander || translate('Commander'),
      errorPath: {
        cpf: error.commander.cpf,
        phone: error.commander.phone
      }
    },
    driver: {
      label: labelDriver || translate('Driver'),
      errorPath: {
        cpf: error.driver.cpf,
        phone: null
      }
    },
    patrolman: {
      label: labelPatrolmans || translate('Patrolman'),
      errorPath: {
        cpf: error.patrolmans.cpf,
        phone: null
      }
    }
  };

  const config = positionConfig[typePosition];
  const errorMessage = config.errorPath;

  return (
    <>
      {config.label}
      {!!errorMessage.cpf &&
        <span style={{ color: 'red' }}>
          {` (${errorMessage.cpf})`}
        </span>
      }
      {!!errorMessage.phone &&
        <span style={{ color: 'red' }}>
          {` (${errorMessage.phone})`}
        </span>
      }
    </>
  );
}
